import React from 'react';

import { WHITELABEL_SETTINGS } from '../../../constants/config';
import AnimatedNexlaMark from './AnimatedNexlaMark';

export default function BrandMark({ animated = false }) {
  const brandMark =
    animated === true && WHITELABEL_SETTINGS.pagingMode === 'default' ? (
      <AnimatedNexlaMark />
    ) : (
      <img alt="logo" style={{ maxHeight: 40 }} src={`${WHITELABEL_SETTINGS.brand.logoMark}`} />
    );

  return <div style={{ marginLeft: 10, marginRight: 10 }}>{brandMark}</div>;
}
